<template>
  <div
    class="size-wrapper"
    v-bind="$attrs"
  >
    <div
      ref="el"
      class="size-wrapper__item"
    >
      <slot />
    </div>
    <MissingSlot
      v-if="!$slots['default']"
      slot-name="default"
      slot-parent="SizeWrapper"
    />
  </div>
</template>

<script lang="ts">
import { useElementSize } from '@vueuse/core'
import { defineComponent, ref, watch } from 'vue'

import MissingSlot from '@/uiKit/MissingSlot/MissingSlot.vue'

/**
 * That component is component wrapper around @vueuse/useElementSize
 * composable.
 * It will emit on its own content height/width change
 */
export default defineComponent({
  components: { MissingSlot },
  setup(_, { emit }) {
    const el = ref(null)
    const { width, height } = useElementSize(el)

    watch(
      () => height.value,
      (value: number) => {
        emit('height', value)
      },
      { immediate: true },
    )

    watch(
      () => width.value,
      (value: number) => {
        emit('width', value)
      },
      { immediate: true },
    )

    return {
      el,
      height,
      width,
    }
  },
})
</script>
